import RequestService from './RequestService.js';
import AppConfig from '../config/ConfigService.js';
import AuthService from '../auth/AuthService.js'


export default class GlasschainMsaHttpClient {
    // Initializing important variables
    constructor() {
        this.appConfig = new AppConfig();
        this.domain = this.appConfig.getMsaCoreServiceHost(); 
        this.testDomain = this.appConfig.getMsaCoreServiceTestHost(); 
        this.notificationDomain = this.appConfig.getNotificationServiceHost();
        this.requestService = new RequestService(this.domain);
        this.requestTestService = new RequestService(this.testDomain);
        this.notificationRequestService = new RequestService(this.notificationDomain);
        this.authService = new AuthService();
    }


    async pingCore() {
        try {
            let loggedInGcid = this.authService.getUser();;
            const url = '/api/dashboard/coreping';
            let result = await this.requestService.fetchJson(url);
            return (result.data == "ping");
        }
        catch (err) {
            console.log(err);
            return false;
        }
    }

    async pingCoreDb() {
        try {
            let loggedInGcid = this.authService.getUser();;
            const url = '/api/dashboard/coredbping';
            let result = await this.requestService.fetchJson(url);
            return (result.data == "ping");
        }
        catch (err) {
            console.log(err);
            return false; 
        }
    }



    async fetchLocationStatusCounts(hoursAgo=24)
    {
      let gcid = this.authService.getGcid();
      const path = "/api/receipt/gcid/" + gcid + "/locationstatuscount/hoursago/" + hoursAgo;
      let toDateData = await this.requestService.fetchJson(path);
      return toDateData;
    }

    async refreshToDateLocationData(){
        try {
            let gcid = this.authService.getGcid();
            const path = '/api/observations/dashboard/gcid/' + gcid + '/location/todatecount';
            let toDateData = await this.requestService.fetchJson(path);
            return toDateData;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }


    async fetchBatchStatusByHour(daysOld) {
        try {
            let gcid = this.authService.getGcid();
            //let qString = "status=" + postStatus;
            const path = '/api/dashboard/gcid/' + gcid + '/postresultbyhour/daysold/' + daysOld;
            var url = path; // + "?" + qString;
            let result = await this.requestService.fetchJson(url);
            return result;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }


    async fetchReceiptsData(receiptDate, warehouse="all") 
    {
        try {
            var location = (warehouse==="ALL") ? "all": warehouse;
            let gcid = this.authService.getGcid();
            //let qString = "status=" + postStatus;
            const path = "/api/receipt/gcid/" + gcid + "/producereceipt/location/" + location + "/receiptdate/" + receiptDate;
            let result = await this.requestService.fetchJson(path);
            console.log("Receipt Result:");
            console.info(result);
            return result.data;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }


    async fetchMasterCatalog(gcid, catalogName) 
    {
        try {
            let gcid = this.authService.getGcid();
            //let qString = "status=" + postStatus;
            const path =  "/api/mastercatalog/gcid/" + gcid + "/" + catalogName;
            let result = await this.requestService.fetchJson(path);
            console.log(catalogName + " Catalog Result:");
            console.info(result);
            return result.data.data;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }


    async fetchSubscribers() 
    {
        try {
            let gcid = this.authService.getGcid();
            //let qString = "status=" + postStatus;
            const path =  "/api/notification/gcid/" + gcid + "/notificationsubscription";
            let result = await this.requestService.fetchJson(path);
            console.info(result);
            return result.data.data;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }


    async fetchDocuments()
    {
        try {
            let gcid = this.authService.getGcid();
            //let qString = "status=" + postStatus;
            const path = "/api/notification/gcid/" + gcid + "/notificationdocument";
            let result = await this.requestService.fetchJson(path);
            console.info(result);
            return result.data.data;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }

    
    async fetchLastWarehousePingEvent()
    {
        try {
            let gcid = this.authService.getGcid();
            //let qString = "status=" + postStatus;
            const path = "/api/telemetry/gcid/" + gcid + "/warehouseprinterpingresult?hasprinterpings=true";
            let result = await this.requestTestService.fetchJson(path);
            console.info(result);
            return result.data.data;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }
  
    async postWarehousePingRequest() 
    {
        try {
            var gcid = this.authService.getGcid();
            const path =  "/api/telemetry/gcid/" + gcid + "/nextautopilotpingrequestid";
            let responseResult = await this.requestTestService.postJson(path, "", true);
            console.log(responseResult);
            return responseResult.data;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }
  
    async postSubscriberDeleteRequest(subscriberId) 
    {
        try {
            var gcid = this.authService.getGcid();
            const path =  "/api/notification/gcid/" + gcid + "/notificationsubscriptiondelete/" + subscriberId;
            let responseResult = await this.requestService.postJson(path, subscriberId, true);
            console.log(responseResult);
            return responseResult.data;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }

    async postSubscriber(subscriber) 
    {
        try {
            var gcid = this.authService.getGcid();
            subscriber.gcid = gcid;
            const path =  "/api/notification/gcid/" + gcid + "/notificationsubscription";
            var postObj = JSON.stringify(subscriber);
            let responseResult = await this.requestService.postJson(path, postObj, true);
            console.log(responseResult);
            return responseResult.data;
        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }
  

}